window.locale = "en";
window.strings = {
    toLang: "To ",
    convertTextToLang: "Convert highlighted text to ",
    showKeyboard: "show keyboard layout",
    hideKeyboard: "hide keyboard layout",
    showAbout: "show about",
    hideAbout: "hide about",
    min: "min",
    sec: "sec",
    readingTime: "reading time",
    speakingTime: "speaking time",
    languages: {
        ru: "Russian",
        uk: "Ukrainian",
        be: "Belarusian",
        bg: "Bulgarian",
        de: "German",
        fr: "French",
        es: "Spanish",
        pt: "Portuguese",
        it: "Italian",
        tr: "Turkish",
        "da/no": "Dano-Norwegian",
        sv: "Swedish",
        fi: "Finnish",
        cs: "Czech",
        nl: "Dutch",
        pl: "Polish",
        hu: "Hungarian",
        ro: "Romanian",
        mi: "Maori",
        fo: "Faroese",
        ic: "Icelandic",
        el: "Greek",
        ka: "Georgian"
    },
    feedbackThanks: "Thank you for your feedback",
    counters: {
        getCharacterPlural(count) {
            return count == 1 ? "character" : `characters`;
        },
        getWordPlural(count) {
            return count == 1 ? "word" : "words";
        }
    }
};
